import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Typeahead} from 'react-bootstrap-typeahead';

export default function TypeaheadSelect(props) {
  const {onChange, className, multiple, value, name, options, inputProps, ...rest} = props;
  const [typeaheadValue, setTypeaheadValue] = React.useState(getTypeaheadValue());

  React.useEffect(() => {
    setTypeaheadValue(getTypeaheadValue());
  }, [value]);

  function getTypeaheadValue() {
    return value ? options.filter(item => value.indexOf(item.value) !== -1) : [];
  }

  const onChangeHandler = React.useCallback(values => {
    setTypeaheadValue(values);
    onChange(values);
  });

  const mergedInputProps = React.useMemo(() => {
    return Object.assign(
      {
        shouldSelectHint: (shouldSelect, e) => {
          return e.keyCode === 13 || shouldSelect;
        },
      },
      inputProps,
    );
  }, inputProps);

  return (
    <Typeahead
      clearButton
      name={name}
      className={classnames('typeahead-select', 'form-control', className)}
      selected={typeaheadValue}
      multiple={multiple}
      onChange={onChangeHandler}
      options={options}
      inputProps={mergedInputProps}
      {...rest}
    />
  );
}

TypeaheadSelect.defaultProps = {
  multiple: false,
  inputProps: {},
};

TypeaheadSelect.propTypes = {
  /** A callback to execute when input changes. Will be passed the input value */
  onChange: PropTypes.func,
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** An id to add to the HTML element. */
  id: PropTypes.string.isRequired,
  /** Name of the slider */
  name: PropTypes.string,
  /** Key to display in the dropdowns */
  labelKey: PropTypes.string.isRequired,
  /** A boolean when passed disables the typeahead select */
  disabled: PropTypes.bool,
  /** A boolean when passed enables or disables multi-select */
  multiple: PropTypes.bool,
  /** A string for typeahead select placeholder */
  placeholder: PropTypes.string,
  /** An array for displaying options in typeahead select */
  options: PropTypes.array,
  /** Default value for typeahead select */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /** Passed to typeahead component */
  inputProps: PropTypes.object,
};
